const reducer = (state = [], action) => {
    if (action.type === "SET_DATA") {
        return action.payload;
    } else {
        return state;
    }    
}
export default reducer;